document.addEventListener('click', function (event) {
  var link = event.target.closest('[data-veteran-size]');
  if (!link) return;
  var guide = document.getElementById('fq-veteran-size');
  if (!guide) return;
  event.preventDefault();
  guide.open = true;
  guide.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center'});
  guide.querySelector('summary').focus({preventScroll: true});
});
